<template>
  <div>
    <v-content>
      <v-container fluid>
        <v-flex lg12 style="padding-left: 0px;">
          <div>
            <v-btn color="success" class="text-xs-right" @click.stop="fncAddRadius()">Add Radius</v-btn>
          </div>
        </v-flex>
        <v-data-table :headers="headers" :items="transportStructure" hide-actions class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
          <template slot="items" slot-scope="props">
            <td width="90%" class="text-xs-right" style="padding-top: 6px;"><v-text-field single-line solo v-model="props.item.radius"></v-text-field></td>
            <td width="10%" class="text-xs-right"><a @click.prevent="fncDeleteRadius(props.item.id)"><i class="material-icons">delete_forever</i></a></td>
          </template>
        </v-data-table>
        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>            
            <v-btn color="success" class="text-xs-right" @click.stop="fncSaveStructure()">Save</v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>

        </div>        
      </v-container>
    </v-content>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Settings',    
    data() {
      return {
        runAdd: false,
        isAddValid: false,
        headers: [
          { text: 'Radius in km', value: 'radius', width: '90%' },
          { text: 'Delete', value: 'delete', width: '10%' }
        ]
        } 
      },
    methods: {
      fncHideModal() {
        this.$store.commit('hideModal');
        this.$store.dispatch('fncPopulateStructure');
      },
      fncDeleteRadius(radiusId) {
        this.$store.commit('fncDeleteRadius', radiusId);
      },
      fncSaveStructure() {
        this.$store.dispatch('fncSaveStructure');
      },
      fncAddRadius() {
      this.$store.commit('fncAddRadius');
      }
      },
      computed: {
		...mapGetters([
          'objAuthorize',
          'globalModalParams',
          'transportStructure'
    ])
  },
  beforeMount() {
    this.$store.dispatch('fncPopulateStructure');
  }
	}
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>